import { memo } from 'react';

import Typography from '@material-ui/core/Typography';

import { ListStyled, useStyles } from './AlertsList.styles';
import { AlertsListProps } from './AlertsList.types';
import { AlertsItem } from './alertsItem/alersItem';

export const AlertsList = memo(({ alertsList = [] }: AlertsListProps) => {
  const styles = useStyles();

  return (
    <div>
      {alertsList.length > 0 && (
        <ListStyled>
          {alertsList.map((alert, i) => {
            return <AlertsItem key={i} alert={alert.title} />;
          })}
        </ListStyled>
      )}
      {alertsList.length === 0 && (
        <div className={styles.noAlertsContainer}>
          <Typography variant="h6">No Alerts Found</Typography>
        </div>
      )}
    </div>
  );
});
